import React, { useEffect, useState } from 'react';
import { ZapIcon } from 'lucide-react';
import { oferta } from '../data/oferta';
export function StickyCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      const nearEnd = window.scrollY + window.innerHeight > document.body.scrollHeight - 700;
      setVisible(window.scrollY > 640 && !nearEnd);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <div aria-hidden={!visible} className={`fixed inset-x-0 bottom-0 z-50 border-t border-gold/30 bg-ink-900 px-3 py-2.5 transition-transform duration-200 ease-out md:hidden ${visible ? 'translate-y-0' : 'translate-y-full'}`} data-id="element-147" data-mp="3ueq3rms5s1vx">
      <div className="flex items-center gap-3" data-id="element-148" data-mp="c67a88mmp4hf">
        <div className="min-w-0" data-id="element-149" data-mp="gxpbkxskd72x">
          <p className="font-sans text-[10px] font-bold uppercase tracking-[0.14em] text-gold" data-id="element-150" data-mp="gxz0sj5sba7k">
            Lanzamiento
          </p>
          <p className="font-display text-xl font-extrabold leading-none text-cream" data-id="element-151" data-mp="765ih1v6iyfz">
            {oferta.precio}
          </p>
        </div>
        <a href={oferta.checkoutUrl} tabIndex={visible ? 0 : -1} className="flex flex-1 items-center justify-center gap-2 rounded-lg bg-gold px-4 py-3 font-sans text-sm font-bold uppercase tracking-wide text-ink-900 transition-colors duration-150 ease-out active:bg-gold-400" data-id="element-152" data-mp="gvfbcjxukl55">
          <ZapIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-153" data-mp="lvjs8b2o3hvw" />
          Comprar ahora
        </a>
      </div>
    </div>;
}